(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ga-subject-catalogue"] && !Shopify.designMode) return;
  try {
    (() => {
  const reveal = hash => {
    let id; try {id=decodeURIComponent(hash.replace(/^#/,''));} catch {return;}
    const card=document.getElementById(id);
    if(card && card.matches('details.u-discovery-card')) {card.open=true;return card;}return null;
  };
  window.addEventListener('hashchange',()=>reveal(location.hash));
  reveal(location.hash);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-universe-feed"] && !Shopify.designMode) return;
  try {
    (() => {
  const cache = new Map();
  const safeURL = (raw) => { try { const u = new URL(raw, location.origin); return ['https:','http:'].includes(u.protocol) ? u : null; } catch { return null; } };
  const storyPath = path => { const start=path.indexOf('/blogs/'); return start<0?path:path.slice(start); };
  const eligible = (a, world) => {
    if (!Array.isArray(a.tags) || !a.tags.includes(world) || !a.tags.includes('universe_approved') || a.tags.includes('universe_exclude') || a.tags.some(t => t.toLowerCase().includes('insider'))) return false;
    // An explicit expiry always wins, even if an evergreen tag was left behind.
    const expiry = a.expires ? Date.parse(a.expires) : null;
    if (a.expires && (!Number.isFinite(expiry) || expiry <= Date.now())) return false;
    return a.tags.includes('universe_evergreen') || expiry > Date.now();
  };
  const score = (a,topics) => topics.reduce((s,t)=>s+(a.tags.includes(t)?(t.startsWith('subject_')?100:10):0),0);
  const rank = (items,topics) => items.map((a,i)=>({a,i,score:score(a,topics)})).sort((a,b)=>b.score-a.score || (Date.parse(b.a.date)||0)-(Date.parse(a.a.date)||0) || a.i-b.i).map(x=>x.a);
  // Relevance first. Featured evergreen may win the final slot only within
  // the strongest remaining relevance tier; it never displaces an exact match.
  const select = (items,topics,limit) => {
    const ranked=rank(items,topics), count=Math.max(1,Math.min(6,Number(limit)||3));
    if(count===1) return ranked.slice(0,1);
    const chosen=ranked.slice(0,count-1), rest=ranked.slice(count-1);
    if(!rest.length) return chosen;
    const tier=rest.filter(a=>score(a,topics)===score(rest[0],topics));
    const lasting=tier.find(a=>a.tags.includes('universe_featured') && a.tags.includes('universe_evergreen')) || tier.find(a=>a.tags.includes('universe_evergreen')) || tier[0];
    if(lasting) chosen.push(lasting);
    return chosen;
  };
  async function getItems(path) {
    if (cache.has(path)) return cache.get(path);
    const promise=(async()=>{
      let next=new URL(path,location.origin), results=[],seen=new Set();
      for(let page=0;next && page<20;page++) {
        if(next.origin!==location.origin || seen.has(next.href)) throw Error('Invalid feed page');
        seen.add(next.href);
        const response=await fetch(next.href,{credentials:'same-origin'});
        if(!response.ok) throw Error('Discovery unavailable');
        const data=JSON.parse(await response.text());
        if(!Array.isArray(data.items)) throw Error('Invalid discovery data');
        results.push(...data.items);
        next=data.next?new URL(data.next,location.origin):null;
        if(next) next.searchParams.set('view','ga-universe-feed');
      }
      return results;
    })();cache.set(path,promise);return promise;
  }
  function hideEmpty(el) {const optional=el.closest('[data-universe-optional]');if(!optional) return;optional.hidden=true;if(optional.id){const root=optional.closest('.ga-u');root?.querySelectorAll('a[href]').forEach(a=>{if(a.getAttribute('href')==='#'+optional.id)a.hidden=true;});}}
  async function renderFeed(el) {
    if(el.dataset.loaded || el.dataset.loading) return;el.dataset.loading='true';
    // Keyboard users must be able to see the focused card in a horizontal feed.
    el.addEventListener('focusin',event=>{
      const card=event.target.closest('a.u-card');
      if(!card || card.parentElement!==el || !card.matches(':focus-visible') || el.scrollWidth<=el.clientWidth) return;
      card.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'});
    });
    try {
      const topics=(el.dataset.topics||'').split(',').filter(Boolean);
      const root=el.closest(".ga-u");
      // Suppress duplicate feature cards, while allowing a source cited inside
      // a collapsed subject guide to be discovered as a feature in its own right.
      const linked=root?[...root.querySelectorAll("a.u-card[data-universe-click=article],a.u-card[data-universe-click=story]")]:[];
      const used=new Set(linked.map(a=>safeURL(a.href)?.pathname).filter(Boolean).map(storyPath));
      const candidates=(await getItems(el.dataset.feedUrl)).filter(a=>eligible(a,el.dataset.world)).filter(a=>{
        const url=safeURL(a.url);if(!url || url.origin!==location.origin || storyPath(url.pathname)===storyPath(location.pathname) || used.has(storyPath(url.pathname))) return false;used.add(storyPath(url.pathname));return true;
      });
      const items=select(candidates,topics,el.dataset.limit);
      for(const a of items) {
        const link=document.createElement('a');link.className='u-card';link.href=a.url;link.dataset.universeClick='story';link.dataset.contentId=a.id;link.dataset.placement=el.dataset.placement;
        if(a.image && safeURL(a.image)) {const img=document.createElement('img');img.src=a.image;img.alt='';img.width=600;img.height=375;img.loading='lazy';link.append(img);}
        const copy=document.createElement('div');copy.className='u-card-copy';
        const type=document.createElement('p');type.className='u-kicker';type.textContent=a.tags.includes('format_podcast')?el.dataset.podcastLabel:a.tags.includes('format_video')?el.dataset.videoLabel:a.tags.includes('format_interview')?el.dataset.interviewLabel:el.dataset.featureLabel;
        const title=document.createElement('h3');title.textContent=a.title;
        const text=document.createElement('p');text.textContent=a.excerpt;
        const cta=document.createElement('span');cta.className='u-link';cta.textContent=el.dataset.readLabel+' →';
        copy.append(type,title);
        const published = new Date(a.date);
        if(Number.isFinite(published.getTime())) {const time=document.createElement('time');time.className='u-story-date';time.dateTime=published.toISOString();time.textContent=published.toLocaleDateString(document.documentElement.lang||'en-GB',{day:'numeric',month:'short',year:'numeric'});copy.append(time);}
        copy.append(text,cta);link.append(copy);el.append(link);
      }
      if(!items.length) {hideEmpty(el);}
    } catch {hideEmpty(el);}
    finally {el.dataset.loaded='true';delete el.dataset.loading;}
  }
  const start=()=>document.querySelectorAll('[data-universe-feed]').forEach(el=>{
    if(!('IntersectionObserver' in window)) return renderFeed(el);
    const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();renderFeed(el);}},{rootMargin:'500px'});observer.observe(el);
  });
  start();document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-universe-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.ga-nav details[open]').forEach(el=>el.removeAttribute('open'));});
document.addEventListener('click',event=>{document.querySelectorAll('.ga-nav').forEach(nav=>{if(!nav.contains(event.target))nav.querySelectorAll('details[open]').forEach(el=>el.removeAttribute('open'));});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-universe-style"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click',event=>{
    const link=event.target.closest('.ga-u a[href^="#"]');
    if(!link || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const hash=link.getAttribute('href');
    let id;try {id=decodeURIComponent(hash.slice(1));} catch {return;}
    const target=document.getElementById(id);
    if(!target || !target.closest('.ga-u')) return;
    if(target.matches('details.u-discovery-card')) target.open=true;
    event.preventDefault();
    // The theme's link handler starts its own animation before this event bubbles.
    if(window.jQuery) window.jQuery('html, body').stop(true);
    if(location.hash!==hash) history.pushState(history.state,'',hash);
    requestAnimationFrame(()=>target.scrollIntoView({behavior:'instant',block:'start'}));
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga-watch-world-links"] && !Shopify.designMode) return;
  try {
    (() => {
  const connect = () => {
    const root = document.getElementById('ga-watch');
    const source = document.getElementById('ga-watch-world-data');
    if (!root || !source || root.dataset.worldLinksReady) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    const routes = new Map(data.routes.map(route => [route.world, route]));
    root.querySelectorAll('.links a[data-shop]').forEach(shop => {
      let path;
      try { path = new URL(shop.href, location.origin).pathname.replace(/\/$/, ''); } catch { return; }
      const all = shop.dataset.shop === 'start-here';
      const route = all ? {url: data.all_shows, world: 'all', name: ''} : routes.get(path.split('/collections/')[1]);
      shop.textContent = all ? data.shop_all : data.shop;
      if (!route) return;
      const wrapper = document.createElement('span');
      wrapper.className = 'ga-u ga-watch-world-link';
      wrapper.dataset.universePage = route.world;
      const link = document.createElement('a');
      link.href = route.url;
      link.textContent = all ? data.explore_all : data.explore;
      link.setAttribute('aria-label', route.name ? route.name + ' · ' + data.explore : data.explore_all);
      link.dataset.universeClick = 'show';
      link.dataset.contentId = route.world;
      link.dataset.placement = 'watch_world';
      wrapper.append(link);
      shop.after(wrapper);
    });
    root.dataset.worldLinksReady = 'true';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect); else connect();
  document.addEventListener('shopify:section:load', connect);
})();
  } catch(e) { console.error(e); }
})();

})();
